<template>
    <section class="content">
        <box title="Filtro">
            
            <div slot="body">
                <div class="row">
                    <div class="col-md-11">
                        <input type="text" class="form-control" v-model="filter">
                    </div>
                </div><br> 
                <router-link class="padding" :to="{ name: 'NotificarClientes', params: { clientes: users}}" >
                    <button class="btn btn-success" >
                    <i class="fa fa-comment paddingRight"></i>Emitir notificações
                    </button>
                </router-link>            
            </div>
        </box>
        <!-- <box :title="'Tabela de '+$route.name"> -->
        <box>    
            <!-- /.box-header -->
            <div slot="body">
                <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
                <div class="row">
                    <div class="col-sm-6">
                    <div id="example1_length" class="dataTables_length">

                    </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 table-responsive">
                    <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                        <thead>
                        <tr>
                            <th v-for="coluna in colunas">
                                <a href="javascript:;" @click="orderCliente(coluna)">{{coluna | ucwords}}</a>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="even" role="row" v-for="u in usersFiltered">
                            <!-- <td><img :src="u.url_foto" class="img-perfil" @error="syncClient(u.fb_id)"/></td> -->
                            <!-- <td>{{u.fb_id}}</td>  -->
                            <td>{{u.nome}}</td>
                            <td>{{u.sobrenome}}</td>
                            <td>{{u.sexo}}</td>
                            <td>{{u.contato}}</td> 
                            <td>{{u.data_nascimento | ajusteData}}</td> 
                            <td><a class="sync" @click="syncClient(u.fb_id, u.id)"><i class="fa fa-refresh" aria-hidden="true"></i></a> </td>
                        </tr>
                                               
                        </tbody>
                        <tfoot>
                        <tr>
                            <th v-for="coluna in colunas">
                                <a href="javascript:;" @click="orderCliente(coluna)">{{coluna | ucwords}}</a>
                            </th>
                        </tr>
                        </tfoot>
                    </table>
                    </div>
                </div>
                </div>
            </div>
                <!-- /.box-body -->
            </box>
    </section>
</template>

<script>

// import $ from 'jquery'
import axios from 'axios'
import _ from 'lodash'
import Box from './Box'
// Require needed datatables modules
// import 'datatables.net'
// import 'datatables.net-bs'

export default {
  name: 'Clientes',
  components: {
      'box': Box
  },
  data () {
    return {
      order: {
        keys: '',
        sort: ''
      },
      users: [],
      colunas: ['nome', 'sobrenome', 'sexo', 'contato','nascimento', ''],
      filter: ''
    }
  },
  created () {
    this.getUsers()
  },
  methods: {
    getUsers () {
      axios.get(`${this.$store.state.api}clientes?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.users = response.data
      })
    },
    orderCliente (coluna) {
        var col
        if(coluna==='id_facebook') col = 'fb_id'
        else col= coluna
        this.order.keys = col
        this.order.sort = this.order.sort === 'desc' ? 'asc' : 'desc'
    },
    syncClient(fb_id, id) {
        // console.log('atualizando imagem ', fb_id)
        // axios.get(`https://graph.facebook.com/v2.7/${fb_id}?access_token=${this.$store.state.fb_page_token}`)
        // .then((ret) => {
        //     this.updateCliente(ret.data, fb_id);
        // })
    },
    updateCliente(cliente, id) {
        axios.put(this.$store.state.api + 'clientes/' + id, {
            nome: cliente.first_name,
            sobrenome: cliente.last_name,
            url_foto: cliente.profile_pic,
            sexo: cliente.gender
        }).then((data) => {
            // this.$router.go()
            this.getUsers()
        })
    }
  },
  filters: {
    ajusteData (value) {
        if (value) {
            let data = value.split('-')
            return [data[2], data[1], data[0]].join('/');
        }
        return value
    },
    ucwords (value) {
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  computed: {
    usersFiltered () {
      let colecao = _.orderBy(this.users, this.order.keys, this.order.sort)
      return _.filter(colecao, item => {
          let nome = `${item.nome.toUpperCase()} ${item.sobrenome.toUpperCase()}`;
        return nome.indexOf(this.filter.toUpperCase()) >= 0 || item.facebook_id.indexOf(this.filter) >=0
      })
    }
  }
}
</script>
<style>
.img-perfil {
    width: 100px;
}
.sync :hover {
cursor:pointer;
}
.paddingTop{
    padding-top: 15px
}
</style>



// WEBPACK FOOTER //
// Clientes.vue?8da000be